import React, { useState, useEffect, useRef } from 'react';
import Axios from 'axios';
import { preload } from './preload';
import { lockWindow } from '../../utils/methods';
import './index.scss';

const PreloadScreen = ({ afterEnd }) => {
  const wrap = useRef(null);
  const circle = useRef(null);
  const [ count, setCount ] = useState(0);
  const [ finish, setFinish ] = useState(false);
  const [ end, setEnd ] = useState(false);

  useEffect(() => {
    loadAsset(0);
    lockWindow(true);
  }, []);

  useEffect(() => {
    if (finish) {
      window.scrollTo(0, 0);
      let i = 1;
      function run() {
        circle.current && circle.current.setAttribute('r', i);
        i += 2;
        if(i < 100) {
          window.requestAnimationFrame(run);
        } 
      }
      window.requestAnimationFrame(run);

      if (document.body.style.overflow !== 'hidden' ) { lockWindow(false) };
      setTimeout(() => setEnd(true), 1000);
    };
  }, [finish]);

  const loadAsset = ( nowLoad ) => {

    const assets = preload;
    
    const instance = Axios.create();
    instance.defaults.timeout = 2000;

    instance.get( `${window.location.origin}/${assets[nowLoad]}` )
      .then((item)=> {
        setCount(count+1);

        // create element
        let path = assets[nowLoad] + '';
        let elem = document.createElement('img');
        elem.setAttribute('src', item.config.url);
        wrap.current.append(elem);

        // next assets
        if (nowLoad + 1 < assets.length) { 
          loadAsset(nowLoad + 1);
        }
        else {
          setFinish(true);
          afterEnd();
        }
      })
      .catch((error)=> {
        console.log(assets[nowLoad] + ' loaded failed.');
        setCount(count+1);
        if (nowLoad + 1 < assets.length) { 
          loadAsset(nowLoad + 1);
          setCount(nowLoad + 1);
        }
      })
  };

  return (
    <React.Fragment>
      {
        !end &&
        <div className={`preload-screen load-cover ${ finish ? 'finish' : ''}`}>
          <div className="wrap" ref={wrap}></div>
          <div className="screen">
              <div className="dot">
                <svg viewBox="0 0 100 100" fill="#FFF">
                  <defs>
                    <mask id="mask1"> 
                      <rect x="0" y="0" width="100" height="100" fill="white" mask="url(#mask1)"/>
                      <circle ref={circle} cx="50" cy="50" r="1" fill="black" />
                    </mask> 
                  </defs> 
                  <rect x="0" y="0" width="100" height="100" fill="#212121" mask="url(#mask1)"/>
                </svg>
              </div>
          </div>
        </div>
      }
    </React.Fragment>
  );
}

export default PreloadScreen;
